<template>
    <div>
        <a-row class="flex">
            <div class="flex items-center">
                <!-- <a-button size="small" class="ml10 mb10" v-if="request_body.role == 35 || request_body.role == 16 || request_body.role == 13 || request_body.role == 1"   @click="addClient">新增甲方单位</a-button> -->
                <a-button size="small" class="ml10 mb10" v-if="user.can_add"   @click="addClient">新增甲方单位</a-button>
                <a-input size="small" allowClear class="mb10 ml10" v-model="search" placeholder="请输入关键字" style="width: 300px" enter-button @change="allowSupplierClear" @pressEnter="onSearch" />
            </div>
            <a-button size="small" class="ml10" type="primary" icon="search" @click="onSearch">
                查询
            </a-button>
        </a-row>
        
        <a-row :gutter="24" type="flex" align="stretch">
            <!-- Table -->
            <a-col :span="24" :lg="30" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
                    <a-table :data-source="data" :columns="columns" class="pd15 w100"  :pagination="false"  size="small" bordered >
                        <span slot="operation" slot-scope="text, record">
                            <a @click="goDetail(record)">详情</a>
                        </span>
                    </a-table>
                    <a-pagination 
                        class="flex items-center mb10"
                        style="justify-content: flex-end"
                        show-quick-jumper  
                        v-model="page.page" 
                        :total="page.total" 
                        :page-size="30"
                        @change="onShowSizeChange" 
                    />
                </a-card>
                
            </a-col>
        
        </a-row>
                   
        <a-modal
            title="查看详情"
            :visible="visibleCheckClient"
            :width="1200"
            :keyboard="true"
            :footer="null"
            @cancel="visibleCheckClient=false"
            :maskClosable="false"
        >       
            <a-button @click="editDetail">
                编辑信息
            </a-button>
            <a-card class="header-solid h-full mt10" :bodyStyle="{padding: 0,}">
                <a-descriptions  layout="vertical" bordered class="w100">
                    <a-descriptions-item label="供应商名称">
                        {{ form.name }}
                    </a-descriptions-item>
                    <a-descriptions-item label="区域">
                        {{ (form.area != null && form.area.length != 0)?form.area:'——' }}
                    </a-descriptions-item>
                    <a-descriptions-item label="详细地址" :span="3">
                        {{ (form.address != null && form.address.length != 0)?form.address:'——' }}
                    </a-descriptions-item>
                    <a-descriptions-item label="联系方式">
                        {{ (form.phone != null && form.phone.length != 0)?form.phone:'——' }}
                    </a-descriptions-item>
                    <a-descriptions-item label="附件" >
                        <div v-for="item, index in form.attachments" :key="index">
                            <a @click="downLoad(item)">
                                {{ item.name }}
                            </a>
                        </div>
                    </a-descriptions-item>
                    <hr>
                </a-descriptions>
                <div class="mt20 mb10">
                    <a-row :gutter="16">
                        <a-col :span="8">
                            <div class="fs13 ml25" style="font-weight: 600;color:#8C8C8C">
                                创建人
                            </div>
                            <div class="ml25" style="color:#1890ff">
                                {{ form.create_person }}
                            </div>
                            <div class="fs13 mt20 ml25" style="font-weight: 600;color:#8C8C8C">
                                修改人
                            </div>
                            <div class="ml25" v-if="form.update_person != null" style="color:#1890ff">
                                {{ form.update_person }}
                            </div>
                            <div class="ml25" v-else>
                                --
                            </div>
                        </a-col>
                        <a-col :span="8">
                            <div class="fs13 ml20" style="font-weight: 600;color:#8C8C8C">
                                创建时间
                            </div>
                            <div class="ml20">
                                {{ form.time }}
                            </div>
                            <div class="fs13 mt20 ml20" style="font-weight: 600;color:#8C8C8C">
                                修改时间
                            </div>
                            <div  class="ml20"> 
                                {{ (form.update_time != null)?form.update_time:'--' }}
                            </div>
                        </a-col>
                    </a-row>
                </div>
            </a-card>
        </a-modal>

        <a-modal
            title="新建甲方单位"
            :visible="visibleAddClient"
            :width="1200"
            :keyboard="true"
            okText="确认"
            cancelText="取消"
            @ok="submit"
            @cancel="cancelAdd"
            :maskClosable="false"
        >
            <a-form size="small">
                <div class="flex">
                    <div class="flex-width pr20" >
                        <div>
                            <div class="mb5 flex">客户名称<div style="color:red">*</div></div>
                            <a-input
                                v-model="form.name"
                                placeholder="请输入客户名称"
                            />
                        </div>
                        <div class="mt15">
                            <div class="mb5">省市区</div>
                            <a-cascader v-model="selectArea" :options="areaData" placeholder="请选择省市区" @change="onChange"/>
                        </div>

                        <div class="mt15">
                            <div class="mb5 flex">备注</div>
                            <a-textarea
                                v-model="form.remark"
                                placeholder="请输入备注"
                                style="width:100%"
                                :auto-size="{ minRows: 2, maxRows: 5 }"
                            />
                        </div>
                        <div class="mt15">
                            <div class="mb5 flex">电话</div>
                            <a-input
                                v-model="form.phone"
                                placeholder="请输入电话"
                            />
                        </div>
                       
                    </div>
                    <div class="flex-width pr20">
                        <div>
                            <div class="mb5">详细地址</div>
                            <a-input
                                v-model="form.address"
                                placeholder="请输入详细地址"
                            />
                        </div>
                        <div class="mt15">
                            <div class="mb5">附件</div>
                            <div class="mt5">
                                <a-upload multiple :action="upload_url" :headers="headers" @change="handleChange" :showUploadList="false">
                                    <a-button size="small"> <a-icon type="upload" /> 上传附件 </a-button>
                                </a-upload>
                            </div>
                            <div class="mt5" v-if="form.attachments != null && form.attachments.length > 0">
                                <div class="flex items-center m-attachment" v-for="(item, i) in form.attachments" :key="i">
                                    <a-icon type="paper-clip" class="mr10" />
                                    <a class="one-line flex-width" @click="preview(item)" style="text-decoration:none;">
                                        <span>{{item.name}}</span>
                                    </a>
                                    <a-icon type="close" class="m-close" @click="removeAttachment(i)" />
                                </div>
                            </div>
                            <!-- <a-upload
                                :action="upload_url"
                                :headers="headers"
                                @change="handleChange" 
                                :default-file-list="defaultFileList"
                                @preview="handlePreview"
                            >
                                <a-button> <a-icon type="upload" /> 上传附件({{form.attachments.length}}/9) </a-button>
                            </a-upload> -->
                        </div>
                    </div>
                </div>
            </a-form>
        </a-modal>
        <a-modal title="预览" v-model="image_visible" @ok="downImg(preview_url)" okText="下载到本地" cancelText="返回" @cancel="image_visible = false">
            <div class="w100 h100">
                <img :src="preview_url" alt="" width="100%" height="100%" style="object-fit: contain;" :data-original="preview_url">
            </div>
        </a-modal>
    </div>
</template>
<script>
import request_body from "/src/utils/request_body.js";
import {areaData} from "../../components/Data/data.js";
const KF = 'updatable';

    export default {
        components: {

        },
        data() {
            return {
                areaData:areaData,
                request_body,
                data:[],
                searchText: '',
                searchInput: null,
                searchedColumn: '',
                columns: [
                    {
                        title: '客户名称',
                        dataIndex: 'name',
                        key: 'name',
                    },
                    {
                        title: '区域',
                        dataIndex: 'area',
                        key: 'area',
                    },
                    // {
                    //     title: '负责人',
                    //     dataIndex: 'introduction',
                    //     key: 'introduction',
                    // },
                    // {
                    //     title: '所属部门',
                    //     dataIndex: 'introduction',
                    //     key: 'introduction',
                    // },
                    {
                        title: '创建人',
                        dataIndex: 'create_person',
                        key: 'create_person',
                    },
                    {
                        title: '创建时间',
                        dataIndex: 'time',
                        key: 'time',
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        key: 'operation',
                        // scopedSlots: { customRender: 'operation' },
                        scopedSlots: { customRender: 'operation' },
                    }
                ],
                page:{
                    page:1,
                    total:0
                },
                search:"",
                visibleAddClient:false,
                visibleCheckClient:false,
                form:{id:0, name:null, area:'', address:'', attachments:[], remark:'', phone:''},
                selectArea:[],
                selectAreaItem:[],
                defaultFileList:[],
                upload_url: "",
			    headers: {},
                user:{
                    can_add:false,
                },
                image_visible:false,
                docVisible:false,
                preview_url:"",
                previewDoc: {
                    title: "",
                    isPdf: false
                },

            }
        },
        created(){
            this.upload_url = this.$api.request_body.url + "/project/upload_assets";
		    this.headers.token = this.$api.request_body.token;
            this.getClientsList()
    
        },
        methods:{
            async getClientsList(){
                let rs = await this.$api.getClientsList(this.search, this.page.page - 1, 30)
                if(rs.err == 0){
                    this.page.total = rs.count
                    this.data = rs.data
                    for(var i = 0; i < this.data.length;i++){
                        this.data[i].key = i + 1;
                        if(this.data[i].attachments != null){
                            this.data[i].attachments = JSON.parse(this.data[i].attachments)
                        }else{
                            this.data[i].attachments = []
                        }
                        // if(this.data[i].area == null){
                        //     this.addArea(this.data[i])
                        // }
                    }
                    if(this.user.can_add != undefined){
                        this.user.can_add = rs.can_add
                    }
                }
            },
            addArea(item){
                if(item.province_name != null){
                    item.area = item.province_name
                }
                if(item.district_name != null){
                    item.area = item.name + '-' + item.province_name
                }
                if(item.city_name != null){
                    item.area = item.name + '-' + item.city_name
                }
            },
            async onSearch(){
                if(this.search.length == 0){
                    this.$notification['warning']({
                        message: '查询条件为空',
                        description:
                        '请选择供应商名称进行查询',
                        style: {
                            width: '600px',
                            marginLeft: `${335 - 600}px`,
                        },
                    });
                    return;
                } else {
                    let rs = await this.$api.goSearchSupplier(this.search, this.page.page - 1,30)
                    if(rs.err == 0){
                        this.data = rs.data
                        for(var i = 0; i < this.data.length;i++){
                            this.data[i].key = i + 1;
                        }
                        this.page.page = 1
                        this.page.total = rs.count
                    }
                }
            },
            onShowSizeChange() {
                if(this.search.length != 0){
                    this.onSearch()
                }else{
                    this.getClientsList()
                }
            },
            allowSupplierClear(){
                if(this.search.length == 0){
                    this.page.page = 1
                    this.getClientsList()
                }
            },
            async addClient(){
                this.form = {id:0, name:null, area:'', address:'', attachments:[], remark:'', phone:''},
                this.selectArea.splice(0)
                this.selectAreaItem.splice(0)
                this.defaultFileList.splice(0)
                // this.clearFileList()
                this.$forceUpdate(this.defaultFileList)
                this.visibleAddClient = true
        
            },
            onChange(value, code) {
                this.selectAreaItem = code
            },
            handleChange({ file, fileList }) {
                if(this.form.attachments.length > 9){
                    this.$message.success(`超出文件数量限制`);
                    return;
                }
                const status = file.status;
                if (file.status === 'uploading') {
                }
                if (status !== 'uploading') {
                }
                if (status !== 'remove') {
                }
                if (status === 'done') {
                    if (file.response.err == 0) {
                        this.form.attachments.push({name:file.name, url:file.response.data})
                        this.$message.success(`${file.name} 上传成功`);
                    } else {
                        this.$message.error(`${file.name} 上传失败`);
                    }
                } else if (status === 'error') {

                }
            },   
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    window.open(file.response.data);
                }
        
            },
            removeAttachment(i) {
                if (this.form.attachments != null) {
                    this.form.attachments.splice(i, 1);
                    this.$forceUpdate();
                }
            },
            preview(item){
                this.previewDoc.title = item.name;
                this.previewDoc.url = item.url;
                this.preview_url = item.url;
                let suffix = this.previewDoc.title.substring(this.previewDoc.title.lastIndexOf(".") + 1)
                if(suffix == "jpg" || suffix == "png"){
                    this.image_visible = true
                }else if(suffix == "rar" || suffix == "zip"){
                    this.$message.error("该文件为压缩包文件，不支持预览，请下载后解压查看")
                }else{
                    if (suffix == "pdf") {
                        const link = document.createElement('a');
                        link.href = item.url;
                        link.download = item.name; // 设置下载的文件名，根据实际需要修改
                        link.target = '_blank'; // 在新窗口打开下载链接
                        link.click(); // 模拟点击触发下载
                    }else if(suffix == "docx" || suffix == "xlsx" || suffix == "pptx"){
                        this.previewDoc.url = "https://api.hidocs.cn/api?furl=" + this.previewDoc.url;
                        window.open(this.previewDoc.url)
                    }else{
                        this.previewDoc.url = "http://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(this.previewDoc.url);
                        window.open(this.previewDoc.url)
                        this.previewDoc.isPdf = false;
                        this.previewDoc.docType = "office";
                        // window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(item.url));

                    }
                }
            },
            async submit(){
                if((this.form.name == null)||(this.form.name.length == 0)){
                    this.$message.success("请填写客户名称")
                    return;
                }
                if(this.selectAreaItem != null && this.selectAreaItem.length != 0){
                    this.form.area = ""
                    for(let item of this.selectAreaItem){
                        this.form.area = ((this.form.area == "")||(this.form.area == null)) ?  item.label : this.form.area + "-" +  item.label
                    }
                    this.form.province_code = this.selectAreaItem[0].code * 1
                    this.form.province_name = this.selectAreaItem[0].label
                    this.form.district_code = this.selectAreaItem[1].code * 1
                    this.form.district_name = this.selectAreaItem[1].label
                    this.form.city_code = this.selectAreaItem[2].code * 1
                    this.form.city_name = this.selectAreaItem[2].label
                }
                // console.log(this.form)
                // this.form.attachments.push({name:"0.3元现金红包.png", url:"https://dayu-build.oss-cn-hangzhou.aliyuncs.com/50aeea91320eaf2b4c0d51ca89330824.png"})
                let rs = await this.$api.addClient(this.form)
                if(rs.err == 0){
                    this.$message.success('保存成功')
                    this.visibleAddClient = false
                    this.getClientsList()
                }else if(rs.err == 2){
                    this.$message.error('客户名称重复')
                }else{
                    this.$message.warn('保存失败，请检查后重试或联系管理员')
                }
            },
            goDetail(record){
                this.form = record
                this.visibleCheckClient = true
            },
            editDetail(){
                this.visibleCheckClient = false
                this.defaultFileList.splice(0)
                // this.clearFileList()
                if(this.form.area != null){
                    this.selectArea = this.form.area.split("-")
                    this.selectAreaItem.splice(0)
                    let as = {code:this.form.province_code, label:this.form.province_name}
                    this.selectAreaItem.push(as)
                    let bs = {code:this.form.district_code, label:this.form.district_name}
                    this.selectAreaItem.push(bs)
                    let cs = {code:this.form.city_code, label:this.form.city_name}
                    this.selectAreaItem.push(cs)
                }
                // if(this.form.attachments.length != 0){
                //     for(let item of this.form.attachments){
                //         let as = {
                //             uid: this.defaultFileList.length + 1,
                //             name: item.name,
                //             status: 'done',
                //             url: item.url,
                //         }
                //         this.defaultFileList.push(as)
                //     }
                // }
                this.visibleAddClient = true
            },
            downImg(item){
                const link = document.createElement('a');
                link.href = item;
                link.download = 'image.jpg'; // 设置下载的文件名，根据实际需要修改
                link.target = '_blank'; // 在新窗口打开下载链接
                link.click(); // 模拟点击触发下载
            },
            downLoad(item){
                const link = document.createElement('a');
                link.href = item.url;
                link.download = item.name; // 设置下载的文件名，根据实际需要修改
                link.target = '_blank'; // 在新窗口打开下载链接
                link.click(); // 模拟点击触发下载
            },
            cancelAdd() {
                this.visibleAddClient=false
                this.defaultFileList = []
                this.getClientsList()
                // location.reload()
            },
        }
    }

</script>

<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
